<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <div class="input-v2">
          <el-date-picker
            class="query-select"
            v-model="queryParams.year"
            type="year"
            format="yyyy"
            value-format="yyyy"
            placeholder="年份"
            @change="getData"
          />
        </div>
        <div class="select-v2">
          <el-select
            class="query-select"
            v-model="queryParams.dataType"
            placeholder="数据类型"
            filterable
            clearable
            @change="getData"
          >
            <el-option
              v-for="item in dataTypeList"
              :key="item.codeItemId"
              :value="item.codeItemId"
              :label="item.codeItemName"
            />
          </el-select>
        </div>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="handleAdd">+ 新增</el-button>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">编辑</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">删除</span>
          </div>
        </template>
      </air-table>
      
      <vxe-pager
        class="pager-v2"
        background
        :current-page.sync="queryParams.page"
        :page-size.sync="queryParams.limit"
        :total="total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
        @page-change="getData"
      ></vxe-pager>
    </div>
    
    <el-dialog class="modal-v2" :title="overallModal.title" :visible.sync="overallModal.show" :close-on-click-modal="false" width="800px" append-to-body>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2" :model="form" :rules="formRules" label-width="110px" style="padding: 30px;">
          <el-form-item label="年份" prop="wageYear">
            <el-date-picker v-model="form.wageYear" class="input-v2" type="year" placeholder="请选择年份" format="yyyy" value-format="yyyy"></el-date-picker>
          </el-form-item>
          <el-form-item label="数据类型" prop="dataType">
            <el-select v-model="form.dataType" class="select-v2" placeholder="请选择数据类型">
              <el-option v-for="item in dataTypeList" :key="item.codeItemId" :label="item.codeItemName" :value="item.codeItemId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人工成本总额" prop="allCost">
            <el-input v-model="form.allCost" class="input-v2" placeholder="请输入人工成本总额">
              <template slot="suffix">万元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="工资总额">
            <el-input v-model="salaryCost" class="input-v2" placeholder="请输入工资总额" disabled>
              <template slot="suffix">万元</template>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="固薪及补贴" prop="fixedSalary">
                <el-input v-model="form.fixedSalary" class="input-v2" placeholder="请输入">
                  <template slot="suffix">万元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="绩效奖金" prop="performanceBonus">
                <el-input v-model="form.performanceBonus" class="input-v2" placeholder="请输入">
                  <template slot="suffix">万元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="协同奖金" prop="collaborativeBonus">
                <el-input v-model="form.collaborativeBonus" class="input-v2" placeholder="请输入">
                  <template slot="suffix">万元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="职工平均人数" prop="avgNumEmployee">
            <el-input v-model="form.avgNumEmployee" class="input-v2" placeholder="请输入职工平均人数" />
          </el-form-item>
          <!--<el-form-item label="人均人工成本">-->
            <!--<el-input v-model="avgCost.avgAllCost" class="input-v2" placeholder="请输入人均人工成本" disabled>-->
              <!--<template slot="suffix">万元</template>-->
            <!--</el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="人均工资水平">-->
            <!--<el-input v-model="avgCost.avgSalaryCost" class="input-v2" placeholder="请输入人均工资水平" disabled>-->
              <!--<template slot="suffix">万元</template>-->
            <!--</el-input>-->
          <!--</el-form-item>-->
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="overallModal.show = false">取消</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
    
    <air-confirm-v2
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
  import { validatenull, validatenum, validatenumord } from '@/util/validate';
  import * as api from '@/api/data-input/data-input'
  
  export default {
    name: 'OverallBudget',
    data() {
      let validateInt = (rule,value,callback)=>{
        if (!validatenull(value)) {
          if (validatenum(value,2)) {
            callback(new Error("请输入整数"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入人数"));
        }
      };
      let validateFloat = (rule,value,callback)=>{
        if(!validatenull(value)){
          if (validatenumord(value,2)) {
            callback(new Error("请输入正确的金额"));
          } else {
            callback();
          }
        }else {
          callback(new Error("金额不能为空"))
        }
      }
      return {
        loading: true,
        dataTypeList: [
          { codeItemName: '预算', codeItemId: 'budget' },
          { codeItemName: '实际', codeItemId: 'actual' }
        ],
        dictMap: {},
        queryParams: {
          year: '',
          dataType: '',
          page: 1,
          limit: 20,
        },
        total: 0,
        columns: [
          {title: '年份', field: 'wageYear', minWidth: 120, fixed: 'left'},
          {title: '数据类型', field: 'dataTypeText', minWidth: 120},
          {title: '人工成本总额（万元）', field: 'allCost', minWidth: 170},
          {title: '工资总额（万元）', field: 'salaryCost', minWidth: 150},
          {title: '固薪及补贴（万元）', field: 'fixedSalary', minWidth: 150},
          {title: '绩效奖金（万元）', field: 'performanceBonus', minWidth: 150},
          {title: '协同奖金（万元）', field: 'collaborativeBonus', minWidth: 150},
          {title: '职工平均人数', field: 'avgNumEmployee', minWidth: 150},
          // {title: '人均人工成本（万元）', field: 'avgAllCost', minWidth: 170},
          // {title: '人均工资水平（万元）', field: 'avgSalaryCost', minWidth: 170}
        ],
        tableData: [],
        form: {},
        formRules: {
          wageYear: [{ required: true, message: '请选择年份', trigger: 'change' }],
          dataType: [{ required: true, message: '请选择数据类型', trigger: 'change' }],
          allCost: [{ required: true, validator: validateFloat, trigger: 'blur' }],
          fixedSalary: [{ required: true, validator: validateFloat, trigger: 'blur' }],
          performanceBonus: [{ required: true, validator: validateFloat, trigger: 'blur' }],
          collaborativeBonus: [{ required: true, validator: validateFloat, trigger: 'blur' }],
          avgNumEmployee: [{ required: true, validator: validateInt, trigger: 'blur' }]
        },
        overallModal: {
          show: false,
          title: '添加信息',
          edit: false
        },
        submitLoading: false,
        confirmShow: false,
        confirmTitle: '',
        confirmContent: '',
        confirmFunction: undefined
      }
    },
    computed: {
      salaryCost() {
        let { fixedSalary = 0, performanceBonus = 0, collaborativeBonus = 0 } = this.form
        fixedSalary = validatenumord(fixedSalary, 2) ? 0 : parseFloat(fixedSalary)
        performanceBonus = validatenumord(performanceBonus, 2) ? 0 : parseFloat(performanceBonus)
        collaborativeBonus = validatenumord(collaborativeBonus,2) ? 0 : parseFloat(collaborativeBonus)
        const costTotal = fixedSalary + performanceBonus + collaborativeBonus
        return costTotal ? costTotal.toFixed(2) : 0
      },
      // avgCost() {
      //   let { allCost = 0, avgNumEmployee = 0 } = this.form
      //   let salaryCost = this.salaryCost
      //   let avgAllCost = 0
      //   let avgSalaryCost = 0
      //   if (!validatenumord(allCost, 2) && avgNumEmployee && validatenum(avgNumEmployee)) {
      //     avgAllCost = (allCost / avgNumEmployee).toFixed(2)
      //   }
      //   if (!validatenumord(salaryCost, 2) && avgNumEmployee && validatenum(avgNumEmployee)) {
      //     avgSalaryCost = (salaryCost / avgNumEmployee).toFixed(2)
      //   }
      //   return {
      //     avgAllCost,
      //     avgSalaryCost
      //   }
      // }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.getData()
      },
      handleSearch() {
        this.queryParams.page = 1
        this.getData()
      },
      getData() {
        this.loading = true
        api.getAllBudget(this.queryParams).then(res => {
          if (!this.dictMap.dataType) {
            this.dictMap.dataType = this.$arrayToObj(this.dataTypeList, 'codeItemId')
          }
          this.tableData = this.$handleTableDict(res.data.data.records, this.dictMap)
          this.total = res.data.data.total
          this.loading = false
        }).catch(() => this.loading = false)
      },
      reset() {
        this.form = {}
        this.submitLoading = false
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      },
      handleAdd() {
        this.reset()
        this.overallModal.title = '添加信息'
        this.overallModal.edit = false
        this.overallModal.show = true
      },
      handleEdit(item) {
        this.form = {
          ...item
        }
        this.overallModal.title = '编辑信息'
        this.overallModal.edit = true
        this.overallModal.show = true
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true
            const params = {
              ...this.form
            }
            let apiFn = this.overallModal.edit ? api.updateAllBudget : api.addAllBudget
            apiFn(params).then(res => {
              if (res.data.code === 0) {
                this.$msgSuccess('保存成功')
                if (this.overallModal.edit) {
                  this.handleSearch()
                }
                this.overallModal.show = false
              }
            }).finally(() => this.submitLoading = false)
          }
        })
      },
      handleDelete(item) {
        this.confirmShow = true
        this.confirmTitle = '删除'
        this.confirmContent = `确认删除「${ item.wageYear }年${ item.dataTypeText }」数据?`
        this.confirmFunction = () => {
          const params = {
            ids: [item.id]
          }
          api.deleteAllBudget(params).then(() => {
            this.getData()
            this.$msgSuccess('删除成功')
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
